// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"footer-module--pageFooter--31kR_"};